import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchClientReviewTableAndFilterSchema } from "model/ClientReviewModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const ClientReviewContext = createContext();

export const ClientReviewProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [clientReviewContextData, setClientReviewContextData] = useState();

  const fetchClientReviewContextData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchMetadataSchema("metadata:clientReview", () =>
        fetchClientReviewTableAndFilterSchema([])
      );
      if (response?.success) {
        setClientReviewContextData(response?.data);
      } else {
        setError(response?.message || "Unable to fetch client review metadata");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ClientReviewContext.Provider
      value={{
        fetchClientReviewContextData,
        clientReviewContextData,
        loading,
        error,
      }}
    >
      {children}
    </ClientReviewContext.Provider>
  );
};

export const useClientReviewContext = () => useContext(ClientReviewContext);
